export const included = [
  'Bio-Scan assessment',
  'Comprehensive 80+ page Bio-Scan report',
  'Approximately one hour of personal feedback with Kandake',
  'Personal Health Summary & First Steps',
]
